export default __webpack_public_path__ + "static/APP_1_2-713da89c93a91c489351a651045e98bd.png";